<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições pelo PRODES:

        .list-group
            a.list-group-item.list-group-item-action
                .row.text-left
                    label.col-6 Ano

                    label.col-5 Área (ha)

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in restricoesOrdenadas'
            )
                .row.text-left
                    .col-6
                        span {{ restricao.properties.ano }}

                    .col-5
                        span {{ formatNumber(restricao.properties.areaHa) }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoProdes"'
        )
</template>

<script>
import formatters from '../../../utils/formatters';

import LayerStyle from '../../../utils/layerStyles';

import Mapa from '../../../components/MapaLeaflet';

export default {
    name: 'Prodes',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        prodes: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            require: true
        }
    },
    computed: {
        restricoesOrdenadas() {
            return this.prodes.restricoes.slice().sort((a, b) => {
                return parseInt(a.properties.ano) - parseInt(b.properties.ano);
            });
        }
    },
    methods: {
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },

        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.prodes.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    name: 'PRODES',
                    geoJson: feature.geometry,
                    tooltip: `${feature.properties.ano}: ${this.formatNumber(
                        feature.properties.areaHa
                    )} ha`
                };

                this.layersMaps.push(layerRestricao);
            });
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
